import gql from 'graphql-tag'


export const get3DSecureForm = gql`
    query get3DSecureForm($paymentId: ID!) {
        get3DSecureForm(paymentId: $paymentId)
    }
`
